/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Fragment, useState } from "react"
import { Menu, Transition } from "@headlessui/react"

import { PageHeader } from "../../../pageHeader"
import { Spinner } from "../../../../layout/Spinner"
import CardItem from "./CardItem"
import { ArrowDown, FaTimes } from "../../../../svgIcons"
import { FooterCTA } from "../../../footerCTA"
import { useResourcesEntries } from "../../../../../hooks/useResourcesEntries"

export const ResourcesListing = ({ entry }) => {
  const resources = useResourcesEntries()

  const [selectedCategory, setSelectedCategory] = useState("All")
  const [filteredResources, setFilteredResources] = useState(resources)

  // Load more funtionality
  const [visible, setVisible] = useState(6)
  const [loading, setLoading] = useState(false)

  const classNames = (...classes) => {
    return classes.filter(Boolean).join(" ")
  }

  const handleCategoryClick = (title) => {
    setSelectedCategory(title)

    if (title === "All") {
      return setFilteredResources(resources)
    }

    const res = resources.filter(
      (resource) => resource.resourceCategory[0]?.title === title
    )

    setFilteredResources(res)
  }

  const handleTopicCategoryClick = (title) => {
    setSelectedCategory(title)

    const res = resources.filter(
      (resource) => resource.resourceTopic[0]?.title === title
    )

    setFilteredResources(res)
  }

  const handleLoadMore = () => {
    setLoading(true)
    setTimeout(() => {
      setVisible(visible + 3)
      setLoading(false)
    }, 100)
  }

  return (
    <>
      <PageHeader {...entry} />

      {/* All Resources */}
      <h1 className="mt-8 text-2xl font-semibold text-center sm:text-3xl md:text-4xl xl:text-5xl 2xl:text-6xl">
        Content Library
      </h1>
      <div className="flex justify-center mt-4">
        <div className="inline-flex h-1 rounded-full w-44 bg-primary" />
      </div>
      <div className="container flex flex-col items-center justify-center mx-auto">
        <div className="justify-center xl:flex">
          <div className="flex flex-wrap mt-6 mb-10">
            <div className="flex flex-wrap justify-center md:mt-10">
              {entry.resourceCategory.map((item, index) => (
                <div
                  key={index}
                  className={`text-secondary text-lg 2xl:text-xl cursor-pointer my-3 xl:my-0 mx-6 xl:mx-4 block
                 border-b-4 border-white hover:border-primary hover:transition duration-100
                 ${
                   selectedCategory === item.title
                     ? "border-primary border-b-4"
                     : null
                 }`}
                  onClick={() => handleCategoryClick(item.title)}
                >
                  {item.title}
                </div>
              ))}
            </div>

            {/* Topics Category */}
            <div className="flex justify-center w-full mt-10 xl:flex-none xl:w-auto">
              <Menu
                as="div"
                className="relative z-10 flex justify-center text-center xl:w-auto xl:inline-block"
              >
                <Menu.Button className="flex mx-4 text-lg font-semibold bg-white rounded 2xl:text-xl text-secondary">
                  Topics
                  <ArrowDown className="w-3 h-3 mt-2 ml-2" />
                </Menu.Button>

                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute text-left origin-top-right bg-white border-2 border-gray-200 rounded-md shadow-lg xl:left-0 top-full ring-1 ring-black ring-opacity-5 focus:outline-none w-60">
                    <div className="py-1">
                      {entry.resourceTopic.map((item, index) => (
                        <Menu.Item key={index}>
                          {({ active }) => (
                            <span
                              className={classNames(
                                active
                                  ? "bg-gray-100 text-secondary"
                                  : "text-secondary",
                                "block px-4 py-2 cursor-pointer"
                              )}
                              onClick={() =>
                                handleTopicCategoryClick(item.title)
                              }
                            >
                              {item.title}
                            </span>
                          )}
                        </Menu.Item>
                      ))}
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
              {selectedCategory !== "All" && (
                <div
                  onClick={() => handleCategoryClick("All")}
                  className="inline-flex items-center justify-center px-1 py-1 text-white rounded opacity-50 cursor-pointer hover:opacity-100 bg-pink"
                >
                  <FaTimes className="p-2 w-7 h-7" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="container flex flex-row items-center justify-center w-11/12 mx-auto mb-20 md:w-10/12">
        <div className="grid grid-cols-1 gap-10 pt-10 sm:grid-cols-2 md:grid-cols-3">
          {filteredResources?.slice(0, visible).map((blog, index) => (
            <CardItem blog={blog} key={index} />
          ))}
        </div>
        {filteredResources?.length === 0 ? (
          <h1 className="py-20 text-lg text-center text-secondary">
            Sorry, no resources found.
          </h1>
        ) : null}
      </div>
      {visible < filteredResources?.length && (
        <div>
          <div aria-hidden="true" onClick={handleLoadMore}>
            {loading ? (
              <Spinner />
            ) : (
              <div className="flex items-center justify-center">
                <button className="px-10 py-4 font-semibold text-white rounded bg-pink hover:bg-btnhover">
                  Show More
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {entry?.footerCTA?.length > 0 && (
        <FooterCTA
          ctaHeading={entry.footerCTA[0].ctaHeading}
          ctaLink={entry.footerCTA[0].ctaLink}
        />
      )}
    </>
  )
}
